import {AUTHORIZATION_RECEIVE_LOGIN, AUTHORIZATION_RECEIVE_LOGIN_ERROR, AUTHORIZATION_REQUEST_LOGIN, AUTHORIZATION_LOGOUT, AUTHORIZATION_CHANGE_USERNAME, AUTHORIZATION_RECEIVE_LOGIN_ROLE_ERROR} from "../config/actions";

let defaultState = {
    authorized: false,
    accessToken: '',
    error: false,
    roleError: false,
    loading: false,
    username : '',
    roles: []
};

const authorizationReducer = (state = defaultState, action) => {
    switch (action.type) {
        case AUTHORIZATION_RECEIVE_LOGIN:
            return Object.assign({}, state, {
                authorized: action.success,
                accessToken: action.accessToken,
                error: false,
                loading: false,
                roleError: false,
                username: action.username,
                roles: action.roles
            });
        case AUTHORIZATION_RECEIVE_LOGIN_ERROR:
            return Object.assign({}, state, {
                authorized: false,
                accessToken: '',
                error: true,
                loading: false
            });
        case AUTHORIZATION_RECEIVE_LOGIN_ROLE_ERROR:
            return Object.assign({}, state, {
                authorized: false,
                accessToken: '',
                error: false,
                roleError: true,
                loading: false
            });
        case AUTHORIZATION_REQUEST_LOGIN:
            return Object.assign({}, state, {
                error: false,
                roleError: false,
                loading: true
            });
        case AUTHORIZATION_LOGOUT:
            localStorage.clear();
            return Object.assign({}, state, {
                authorized: false,
                accessToken: '',
                error: false,
                roleError: false,
                loading: false,
                username: ''
            });
        case AUTHORIZATION_CHANGE_USERNAME:
            return Object.assign({}, state, {
                username: action.username
            });
        default:
            return state;
    }
};

export default authorizationReducer;